// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"31d6cfe0","964":"b749a687"}[chunkId] + ".chunk.css";
};